import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../services'

import { Input, Button, Card, CardBody, CardHeader } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
import './ScanResults.scss'

const { useHistory } = require('react-router-dom')

interface Props {
  code?: string;
  onClose?: () => void;
}
const ScanResults: React.FC<Props> = (props) => {

  const code = props.code
  const user = useSelector(state => state.authReducer.user)
  const [results, setResults] = React.useState<any>({
    data: null,
    error: null,
  })
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    if (code)
      check()
  }, [code])

  const check = async () => {
    setLoading(true)

    try {
      //const res: any = { code: 'already_validated', data: null }
      const res = await Fire.cloud('scanTicket', { code: code })
      Tools.vibrate()
      let err = ''
      if (res.code) {
        switch (res.code) {
          case "already_validated":
            const date = res.validatedAt || new Date()
            err = 'Ticket déjà validé à ' + date
            break;

          case "invalid_ticket":
            err = 'Ticket invalide'
            break;
          
          default:
            err = 'Erreur de connexion'
            break;
        }
      }
      setResults({ data: res.data, error: err })
    } catch (err) {
    }

    setLoading(false)
  }

  const close = () => {
    if (loading)
      return;

    setResults({ data: null, error: null })
    setLoading(false)

    if (props.onClose)
      props.onClose()
  }

  if (!code)
    return (null);

  return (
    <div className="scan-response-wrapper" onClick={close}>
      <div className={["scan-response", results.data ? "success" : results.error ? "fail" : ''].join(' ')}>
        {loading ? (
          <span className="scan-confirm">Validation...</span>
        ) : results.data ? (
          <span className="scan-confirm">Ticket validé</span>
        ) : (
          <span className="scan-confirm">{results.error}</span>
        )}

        <div className="scan-close">
          <i className="fa fa-close"></i>
        </div>
      </div>
    </div>
  );
}

export default ScanResults